import { Component } from "@angular/core";
import { Talent } from "../../api/sign-up/signup.types";
import { ActivatedRoute } from "@angular/router";
import { AccountStatus, LoginData } from "../login-page/login-page-data/login.types";
import { LoginService } from "../login-page/login-page-data/login.service";
import { ProfileService } from "../../api/profile/profile.service";
import { catchError, EMPTY, ObservableInput, Subject } from "rxjs";
import { GoogleAnalyticsService } from "@hakimio/ngx-google-analytics";
import {TranslateService} from "@ngx-translate/core";
import {Title} from "@angular/platform-browser";

@Component({
  selector: "mh-register-talent",
  templateUrl: "./register-talent.component.html",
  styleUrls: ["./register-talent.component.less"],
})
export class RegisterTalentComponent {
  currentStep = 0;
  profile!: Talent;
  loginData: LoginData;
  loading = false;
  destroy$ = new Subject<void>();

  constructor(
    private loginService: LoginService,
    private profileService: ProfileService,
    private activatedRoute: ActivatedRoute,
    private gaService: GoogleAnalyticsService,
    private translateService: TranslateService,
    private titleService: Title,
  ) {
    this.profile = this.activatedRoute.snapshot.data["profile"];
    this.loginData = this.activatedRoute.snapshot.data["loginData"];

    if (!this.loginData?.accountStatuses?.includes(AccountStatus.CONFIRMED)) {
      this.currentStep = 3;
    }
    if (!this.loginData?.accountStatuses?.includes(AccountStatus.VERIFIED)) {
      this.currentStep = 2;
    }
    if (this.profile.email && !this.profile.reasonWhy && !this.loginData?.accountStatuses?.includes(AccountStatus.VERIFIED)) {
      this.currentStep = 1;
    }
    if (!this.profile.email) {
      this.currentStep = 0;
    }
    this.trackCurrentStep(this.currentStep);
  }

  pre(): void {
    this.currentStep -= 1;
  }

  next(): void {
    this.currentStep += 1;
    this.trackCurrentStep(this.currentStep);
  }

  done(): void {
    console.log("done");
  }

  onNextStep() {
    this.next();
    window.scrollTo({ top: 0 });
  }

  onTalentChange(value: Talent) {
    this.profile = {
      ...this.profile,
      ...value,
    };
  }

  onRegistered(data: { token: string; account: Talent }) {
    this.loginService.setToken(data.token);
    this.onTalentChange(data.account);
  }

  onUserUpdate(): void {
    this.loading = true;
    this.profileService
      .talentUpdate(this.profile as Talent)
      .pipe(
        catchError((): ObservableInput<any> => {
          this.loading = false;
          return EMPTY;
        }),
      )
      .subscribe((result) => {
        this.loading = false;
        if (result) this.next();
      });
  }

  trackCurrentStep(currentStep: number) {
    switch (currentStep) {
      case 0:
        this.gaService.event("sign_up_0", { category: "talent_sign_up", label: "Email password form" });
        this.titleService.setTitle(this.translateService.instant("page.title", { pageName: this.translateService.instant('reg.talent.title') }));
        break;
      case 1:
        this.gaService.event("sign_up_1", { category: "talent_sign_up", label: "Short profile form" });
        this.titleService.setTitle(this.translateService.instant("page.title", { pageName: this.translateService.instant('reg.talent.job-prefs.title') }));
        break;
      case 2:
        this.gaService.event("sign_up_2", { category: "talent_sign_up", label: "Phone verification" });
        this.titleService.setTitle(this.translateService.instant("page.title", { pageName: this.translateService.instant('reg.talent.phone-verification.title') }));
        break;
      case 3:
        this.gaService.event("sign_up_email_doi_block", { category: "talent_sign_up", label: "Email verification" });
        this.titleService.setTitle(this.translateService.instant("page.title", { pageName: this.translateService.instant('reg.talent.email-confirmation.title') }));
        break;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
